'use strict';

function ctrl($scope, Global, timeFormat, $location, $http, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.geoChartIdentifiers = {
        key: false,
        id: false
    };
    model.tableIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/archive').then(function(socket) {
        /////////////////
        /// LINECHART ///
        /////////////////

        // register data object
        $scope.main.registerVisual({
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'linechart',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                grouping: ['hour', 'remote_country'],
                type: 'linechart',
                settings: {
                    type: 'severity',
                    xAxis: '',
                    yAxis: '# IOC / Hour'
                },
                searchCategories: {
                    'time': 'Time',
                    'remote_country': 'Remote Country',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        if (d.time - d.hour < 3600) {
                            d.hour = Number(d.hour * 1000);
                            return d.hour;
                        }
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduce(
                        function(p, v) {
                            if (v.ioc_severity === 1) {
                                p.guarded += v.count;
                            }
                            if (v.ioc_severity === 2) {
                                p.elevated += v.count;
                            }
                            if (v.ioc_severity === 3) {
                                p.high += v.count;
                            }
                            if (v.ioc_severity === 4) {
                                p.severe += v.count;
                            }
                            return p;
                        },
                        function(p, v) {
                            if (v.ioc_severity === 1) {
                                p.guarded -= v.count;
                            }
                            if (v.ioc_severity === 2) {
                                p.elevated -= v.count;
                            }
                            if (v.ioc_severity === 3) {
                                p.high -= v.count;
                            }
                            if (v.ioc_severity === 4) {
                                p.severe -= v.count;
                            }
                            return p;
                        },
                        function() {
                            return {
                                guarded: 0,
                                elevated: 0,
                                high: 0,
                                severe: 0
                            };
                        }
                    );
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.lineChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
                // return new fetchStream(result.settings.get.call, result.settings.get.socket);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                // stop spinner on complete
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.lineChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                } else {
                    $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
                }
            })

        ////////////////
        /// GEOCHART ///
        ////////////////

        // register data object
        $scope.main.registerVisual({
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'geomap',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                grouping: ['remote_country'],
                searchCategories: {
                    'remote_country': 'Remote Country',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        return d.remote_country;
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduceSum(function(d) {
                        return d.count
                    }); //Might have to Math.ceil or round
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.geoChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            // fetch the data when the object is registered
            .then(function(result) {
                // stop spinner on complete or no data
                if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.geoChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
                } else {
                    $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
                }
            })

        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: ['local_ip', 'local_hostname', 'remote_ip', 'ioc_class'],
                sort: {
                    direction: "-",
                    col: "time"
                }, // "-"=desc, "+"=asc
                title: 'Archived Indicators of Compromise (IOC) Notifications',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'ioc_drill',
                        val: ['local_ip', 'local_hostname', 'remote_ip', 'ioc_class'],
                        crumb: false
                    },
                }, {
                    title: 'Severity',
                    select: 'ioc_severity',
                    dView: true
                }, {
                    title: 'IOC Events',
                    select: 'count',
                    dView: true
                }, {
                    title: 'IOC',
                    select: 'ioc_class',
                    dView: true
                }, {
                    title: 'IOC Type',
                    select: 'ioc_type',
                    dView: true
                }, {
                    title: 'IOC Stage',
                    select: 'ioc_stage',
                    dView: true
                }, {
                    title: 'IOC Rule',
                    select: 'ioc_rule',
                    dView: true
                }, {
                    title: 'Local IP',
                    select: 'local_ip',
                    dView: true
                }, {
                    title: 'Local Hostname',
                    select: 'local_hostname',
                    dView: true
                }, {
                    title: 'Remote IP',
                    select: 'remote_ip',
                    dView: true
                }, {
                    title: 'Remote ASN',
                    select: 'remote_asn_name',
                    dView: true
                }, {
                    title: 'Remote Country',
                    select: 'remote_country',
                    dView: true
                }, {
                    title: 'Flag',
                    select: 'remote_cc',
                    dView: true
                }, {
                    title: 'Packets to Remote',
                    select: 'in_packets',
                    dView: true
                }, {
                    title: 'Packets from Remote',
                    select: 'out_packets',
                    dView: true
                }, {
                    title: 'Bandwidth to Remote',
                    select: 'bytes_in',
                    dView: false
                }, {
                    title: 'Bandwidth from Remote',
                    select: 'bytes_out',
                    dView: false
                }, ],
                searchCategories: {
                    'ioc_severity': 'Severity',
                    'ioc_count': 'IOC Events',
                    'ioc_class': 'IOC',
                    'ioc_type': 'IOC Type',
                    'ioc_stage': 'IOC Stage',
                    'ioc_rule': 'IOC Rule',
                    'local_hostname': 'Local Hostname',
                    'local_user': 'Local User',
                    'local_ip': 'Local IP',
                    'remote_ip': 'Remote IP',
                    'remote_country': 'Remote Country',
                    'remote_cc': 'Flag',
                    'remote_asn_name': 'Remote ASN',
                    'bytes_in': 'Bandwidth to Remote',
                    'bytes_out': 'Bandwidth from Remote',
                    'in_packets': 'Packets to Remote',
                    'out_packets': 'Packets from Remote'
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })

    $scope.rootpage = true;
    $scope.archiveBtn = true;
    $scope.emptyarchive = function() {
        var r = confirm("Are you sure?");
        if (r === true) {
            $http({
                    method: 'POST',
                    url: api + '/api/actions/clear'
                })
                .success(function(data, status, headers, config) {
                    // $route.reload();
                    $location.path('/');
                })
                .error(function(data, status, headers, config) {
                    alert('There was an error clearing Archive. Please try again in a couple minutes.')
                });
        }
    }
    $scope.rootpage = true;
}

ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$location', '$http', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/archive.js
 **/